
export function height(el) {
  let height = el.clientHeight
  const computedStyle = getComputedStyle(el);
  height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
  return height
}
